import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AccountState {
    name: string;
    companyName: string;
    roleName: string;
    appId: string;
    userId: string;
    isAuthenticated: boolean;
    isReviewer: boolean;
}

const initialState: AccountState = {
    name: '',
    companyName: '',
    roleName: '',
    appId: '',
    userId: '',
    isAuthenticated: false,
    isReviewer: false
};

const accountSlice = createSlice({
    name: 'account',
    initialState,
    reducers: {
        setName: (state, action: PayloadAction<string>) => {
            state.name = action.payload;
        },
        setCompanyName: (state, action: PayloadAction<string>) => {
            state.companyName = action.payload;
        },
        setRole: (state, action: PayloadAction<string>) => {
            state.roleName = action.payload;
        },
        setAppId: (state, action: PayloadAction<string>) => {
            state.appId = action.payload;
        },
        setUserId: (state, action: PayloadAction<string>) => {
            state.userId = action.payload;
        },
        setIsAuthenticated: (state, action: PayloadAction<boolean>) => {
            state.isAuthenticated = action.payload;
        },
        setIsReviewer: (state, action: PayloadAction<boolean>) => {
            state.isReviewer = action.payload;
        },
    },
});

export const { setName, setCompanyName, setRole, setAppId, setUserId, setIsAuthenticated, setIsReviewer } = accountSlice.actions;
export default accountSlice.reducer;
